import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, X } from 'lucide-react';
const NAMES = ['María', 'Sofía', 'Valentina', 'Lucía', 'Camila', 'Martina', 'Florencia', 'Daniela', 'Carla', 'Romina', 'Agustina', 'Paula', 'Julieta', 'Gabriela', 'Mariana', 'Belén', 'Carolina', 'Natalia', 'Rocío', 'Verónica', 'Andrea', 'Micaela', 'Antonella', 'Brenda', 'Yamila'];
const LASTNAMES = ['G.', 'P.', 'R.', 'M.', 'C.', 'T.', 'S.', 'L.', 'F.', 'B.', 'D.', 'V.', 'A.'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'San Miguel de Tucumán', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca', 'Paraná', 'Formosa', 'San Luis', 'Corrientes', 'Río Cuarto', 'Comodoro Rivadavia', 'San Rafael', 'Tandil', 'Quilmes', 'Lanús', 'Pilar'];
const OFFERS = ['Método Escribo Jugando — Oferta de hoy $24.990', 'Pack Completo Escribo Jugando + Plantillas Imprimibles'];
const TIME_AGO = ['hace 2 minutos', 'hace 5 minutos', 'hace 1 minuto', 'hace 8 minutos', 'hace unos segundos', 'hace 3 minutos', 'hace 10 minutos'];
function pick<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
interface SaleData {
  name: string;
  city: string;
  offer: string;
  timeAgo: string;
}
function generateSale(): SaleData {
  return {
    name: `${pick(NAMES)} ${pick(LASTNAMES)}`,
    city: pick(CITIES),
    offer: pick(OFFERS),
    timeAgo: pick(TIME_AGO)
  };
}
// Random interval between 40 and 60 seconds
const nextInterval = () => (40 + Math.random() * 20) * 1000;
export function SalesNotification() {
  const [sale, setSale] = useState<SaleData | null>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    let nextTimer: ReturnType<typeof setTimeout>;
    const showOne = () => {
      setSale(generateSale());
      setVisible(true);
      // Keep it on screen for ~6 seconds
      hideTimer = setTimeout(() => {
        setVisible(false);
        // Schedule the next one 40-60s after this one disappears
        nextTimer = setTimeout(showOne, nextInterval());
      }, 6000);
    };
    // First popup after an initial short delay
    const initial = setTimeout(showOne, 6000);
    return () => {
      clearTimeout(initial);
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, []);
  return <div className="fixed bottom-4 left-4 z-50 max-w-[calc(100vw-2rem)]" data-id="element-200">
      <AnimatePresence data-id="element-201">
        {visible && sale && <motion.div key={`${sale.name}-${sale.timeAgo}`} initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 26
      }} className="flex items-start gap-3 bg-white rounded-2xl shadow-soft border border-slate-100 p-4 pr-9 w-80 relative" role="status" aria-live="polite" data-id="element-202">
            <button onClick={() => setVisible(false)} aria-label="Cerrar notificación" className="absolute top-2 right-2 text-slate-300 hover:text-slate-500 transition-colors" data-id="element-203">
              <X size={16} data-id="element-204" />
            </button>

            <div className="bg-green-100 p-2 rounded-full shrink-0" data-id="element-205">
              <CheckCircle2 className="text-green-600" size={22} data-id="element-206" />
            </div>

            <div className="min-w-0" data-id="element-207">
              <p className="text-sm font-bold text-brand-dark leading-snug" data-id="element-208">
                {sale.name}{' '}
                <span className="font-medium text-brand-text" data-id="element-209">
                  de {sale.city}
                </span>
              </p>
              <p className="text-xs text-brand-text leading-snug mt-0.5" data-id="element-210">
                acaba de comprar{' '}
                <span className="font-semibold text-brand-dark" data-id="element-211">
                  {sale.offer}
                </span>
              </p>
              <p className="text-[11px] text-green-600 font-semibold mt-1.5 flex items-center gap-1" data-id="element-212">
                <span className="inline-block w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" data-id="element-213" />
                Compra verificada · {sale.timeAgo}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}